@import 'vars';

$item-height: 40px;
$item-width: 170px;

.contact-popover {
  padding: $padding-medium;
  gap: $padding-medium;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 100%;

  &__type {
    &__teams-logo {
      width: 15px;
      height: auto;
    }
  }

  &__heading {
    min-width: $item-width;
    display: flex;
    gap: $padding-small;
    align-items: center;
    align-self: flex-start;
  }

  &__info {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__section {
    min-width: $item-width;
    min-height: $item-height;
    height: fit-content;
    padding-top: $padding-medium;
    display: flex;
    align-items: center;
    gap: 10px;
    border-top: $border-size-thin solid $mid-grey;

    &:not(:last-child) {
      padding-bottom: $padding-medium;
    }
  }

  &__details {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: $padding-xsmall;
    overflow: hidden;
    text-overflow: ellipsis;

    &__name {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__detail {
      width: 100%;
      height: 25px;
      display: flex;
      gap: $padding-small;
      align-items: center;

      &__icon {
        vertical-align: text-bottom;
      }
    }
  }
}

.task-status-badge--style-override {
  border-radius: 2px;
  height: 16px;
}
